/**
 * Returns whether v matches the BingMapsResourceSet type
 * @param v
 */
export function isBingMapsResourceSet(v) {
    if (typeof v !== "object")
        return false;
    if (typeof v.estimatedTotal !== "number")
        return false;
    if (typeof v.resources === "undefined" || !Array.isArray(v.resources))
        return false;
    for (const i of v.resources) {
        if (typeof i !== "object")
            return false;
    }
    return true;
}
